<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑' : '新增'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 17 }"
    >
      <!-- 星图ID -->
      <a-form-item
        label="星图ID"
        name="xt_author_id"
        :rules="[
          { required: true, validator: validatorStarId }
        ]"
      >
        <a-input v-model:value="formState.xt_author_id" placeholder="请输入" />
      </a-form-item>

      <!-- 抖音号名称 -->
      <a-form-item label="抖音号名称" name="name"  :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="formState.name" placeholder="请输入" />
      </a-form-item>

      <!-- 机构 -->
      <a-form-item label="机构" name="provider_id"  :rules="[{ required: true, message: '请输入' }]">
        <a-select v-model:value="formState.provider_id" placeholder="请选择">
          <a-select-option
            v-for="item in agencyList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <!-- 团长 -->
      <a-form-item label="团长" name="leader_id"  :rules="[{ required: true, message: '请输入' }]">
        <a-select v-model:value="formState.leader_id" placeholder="请选择">
          <a-select-option
            v-for="item in leaderList"
            :key="item.id"
            :value="item.id"
            >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- 姓名 -->
      <a-form-item label="姓名" name="real_name">
        <a-input v-model:value="formState.real_name" placeholder="请输入" />
      </a-form-item>

      <!-- 身份证 -->
      <a-form-item label="身份证" name="id_number">
        <a-input v-model:value="formState.id_number" placeholder="请输入" />
      </a-form-item>

      <!-- 银行卡号 -->
      <a-form-item label="银行卡号" name="bank_account">
        <a-input v-model:value="formState.bank_account" placeholder="请输入" />
      </a-form-item>

      <!-- 手机号 -->
      <a-form-item
        label="手机号"
        name="phone"
        :rules="[{ validator: validatorPhone }]"
      >
        <a-input v-model:value="formState.phone" placeholder="请输入手机号" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick, watch } from 'vue'
import { message } from 'ant-design-vue'
import { talentSave } from '@/api/agency'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { agencySearch as fetchAgencyList, leaderSearch as fetchLeaderList } from '@/api/agency'

// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(null)
// 表单数据
let formState = reactive({
  xt_author_id: undefined,
  name: undefined,
  provider_id: undefined,
  leader_id: undefined,
  real_name: undefined,
  id_number: undefined,
  bank_account: undefined,
  phone: undefined
})
// 加载
let isLoading = ref(false)

const agencyList = ref([])      // 机构下拉数据
const leaderList = ref([])      // 团长下拉数据

// 校验：星图ID 仅限数字
function validatorStarId (rule, value) {
  if (!Pub.REG_IS_NUMBER(value)) return Promise.reject('仅限数字')
  return Promise.resolve()
}

// 校验：手机号
function validatorPhone (rule, value) {
  if (value && !Pub.REG_IS_PHONE(value)) {
    return Promise.reject('手机号格式不正确')
  }
  return Promise.resolve()
}

function loadAgencies () {
  fetchAgencyList({ page: 1, page_size: 500 }).then(res => {
    const { code, data, msg } = res
    if (code === 0) {
      agencyList.value = data || []
    } else {
      message.error(res.message || msg)
    }
  })
}

function loadLeaders () {
  const params = {
    provider_id: formState.provider_id,
    page: 1,
    page_size: 500
  }
  fetchLeaderList(params).then(res => {
    const { code, data, msg } = res
    if (code === 0) {
      leaderList.value = data || []
    } else {
      message.error(res.message || msg)
    }
  })
}

// 当机构变更时，联动刷新团长列表
watch(() => formState.provider_id, () => {
  loadLeaders()
})

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // id
  id.value = params.id
  // 下拉数据
  loadAgencies()
  // 赋值
  nextTick(() => {
    if (params.id) {
      Object.assign(formState, {
        xt_author_id: params.xt_author_id,
        name: params.name,
        provider_id: params.provider_id,
        leader_id: params.leader_id,
        real_name: params.real_name,
        id_number: params.id_number,
        bank_account: params.bank_account,
        phone: params.phone
      })
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    talentSave({
      id: id.value,
      ...formState
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        onClose()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>

</style>